import React, { useEffect, useState } from "react";
import { cookies } from "../../store/actions";
import cookieSVG from "../../assets/cookie.svg";
import downArrow from "../../assets/downArrowCookie.svg";
import closeCookie from "../../assets/closeCookie.svg";
import cookieIcon from "../../assets/cookieIcon.png";

import * as S from "./style";


declare global {
  interface Window {
    dataLayer: any[];
  }
} 

const Cookies: React.FC = () => {
  const [showBanner, setShowBanner] = useState(!cookies.get("unitiva")); //da mettere un use effect sul cookie denied
  const [showMoreLink, setShowMoreLink] = useState(false);
  const [activeSection, setActiveSection] = useState("section1");
  const [checkedSwitch, setCheckedSwitch] = useState(false);
  const [sections, setSections] = useState({
    section1: false,
    section2: false,
  });
  const [underSections, setUnderSection] = useState({
    underSection1: false,
    underSection2: false,
  })

  const toggleUnderSection = (underSection: string) => {
    setUnderSection((prevState: any) => ({
      ...prevState,
      [underSection]: !prevState[underSection],
    }))
  }
  const toggleSection = (section: string) => {
    setSections((prevState: any) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const handleViewSetting = (e: any) => {
    e.preventDefault();
    setShowMoreLink(!showMoreLink);
  }

  const openSection = (sectionName: string) => {
    setActiveSection(sectionName);
  }

  const handelCheckBox = () =>{
    if(checkedSwitch){
      setCheckedSwitch(false);
    }else{
      setCheckedSwitch(true);
    }
  }
  
  const acceptCookie = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    cookies.remove('unitiva');
    cookies.remove('Google_analytics');
    cookies.remove("_ga");
    cookies.remove("_ga_BL3RMG61CV");
    cookies.set('unitiva', 'accepted', { maxAge: 345600 });
    cookies.set('Google_analytics', 'true', { maxAge: 345600 });
    generateCookieAnalytics();
    sessionStorage.removeItem("cookieDenied");
   
    setShowBanner(false);
  };

  const acceptCookiePreference = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    cookies.remove("Google_analytics");
    cookies.remove("_ga");
    cookies.remove("_ga_BL3RMG61CV");
    cookies.remove("unitiva");
    cookies.set('unitiva', 'accepted', { maxAge: 345600 });
    if (checkedSwitch) {
      cookies.set('Google_analytics', 'true', { maxAge: 345600 });
      generateCookieAnalytics();
    } 
    setShowBanner(false);
    sessionStorage.removeItem("cookieDenied");
  };

  const generateCookieAnalytics = () => {
    const googleAnalytics = cookies.get('Google_analytics');
    if (googleAnalytics === 'true') {
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BL3RMG61CV';
      script.async = true;
      document.head.appendChild(script);
      console.log("script added");

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
      }
        gtag('js', new Date());
        gtag('config', 'G-BL3RMG61CV');
        console.log("script added2")
      };
    }
  };

  const denyCookie = (e: any) =>{
    e.preventDefault();
    sessionStorage.setItem("cookieDenied", "true");
    cookies.remove("Google_analytics");
    cookies.remove("_ga");
    cookies.remove("_ga_BL3RMG61CV");
    cookies.remove("unitiva");
    setShowBanner(false);
  }

  useEffect(()=>{
    if(sessionStorage.getItem("cookieDenied") === "true"){
      setShowBanner(false);
    }
  },[sessionStorage.getItem("cookieDenied") === "true"]);

  return showBanner ? (
    <S.CookiesWrapper className={`cookies ${showMoreLink ? "expanded": ""}`} id="cookiesBanner">
      <div className="container">
        <div className="flex-row">
          <div className="cols">
            <p className="p-cookie1" style={{padding: "10px"}}>Questo sito utilizza cookie e tecnologie simili per garantirne il corretto
              funzionamento e per migliorare la tua esperienza di navigazione. Puoi accettare tutti i cookie,
              rifiutarli o personalizzare le tue preferenze. Per maggiori informazioni, consulta la nostra<a
                style={{fontSize: "15px"}} href="https://unitiva.it/cookie" target="_blank"> Cookie Policy.</a>
            </p>
            <div className="cookieSwitch-container">
              <div className="underCookieSwitchContainer">
                <p className="p-cookie">Cookie tecnici</p>
                <label className="switchCookie">
                  <input type="checkbox" className="checkboxSwitchDis" id="unitivaCheckbox" checked disabled />
                  <span className="sliderCookie round"></span>
                </label>
              </div>
              <div className="underCookieSwitchContainer">
                <p className="p-cookie">Cookie analitici</p>
                <label className="switchCookie">
                  <input type="checkbox" className="checkboxSwitch" id="analyticsCheckbox" checked={checkedSwitch} onChange={handelCheckBox}/>
                  <span className="sliderCookie round"></span>
                </label>
              </div>
              <a id="showMoreLink" href="#" onClick={handleViewSetting}>Impostazioni cookie &nbsp; &nbsp; &nbsp; <i className="main__btn__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 1024 1024"
                  className="icon" version="1.1">
                  <path d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z" fill="#000000" />
                  <path xmlns="http://www.w3.org/2000/svg"
                    d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z" fill="#000000" />
                </svg>
              </i>
              </a>
            </div>

            <div className="tabs-container">
              <div className="header-tabs">
                <img src={cookieSVG} alt="cookie" style={{ width: '50px', height: '50px', marginLeft: "2%"}} />
                <a id="closeLink" href="#" onClick={handleViewSetting}><i className="main__btn__icon" >
                  <img src={closeCookie} alt="close" style={{width: '20px', height: '20px'}} />
                </i>
                </a>
              </div>



              <hr className="hrCookieSection" />
              <div className="tabs">
                <button className={`tablink ${activeSection === 'section1' ? 'active' : ''}`}
                  onClick={() => openSection('section1')}
                  id="defaultOpen">Consent</button>
                <button className={`tablink ${activeSection === "section2" ? "active" : ""}`} onClick={() => openSection("section2")}>Dettagli</button>
              </div>
              <hr className="hrCookieSection" />




              <div id="section1" className={`tabcontent ${activeSection === 'section1' ? 'active' : ''}`}>
                <h4 className="h4Cookie">Questo sito utilizza i cookies.</h4>
                <p style={{ color: "black" }}>Questo sito utilizza cookie e tecnologie simili per garantirne il corretto funzionamento e per
                  migliorare la tua esperienza di navigazione. Puoi accettare tutti i cookie, rifiutarli o
                  personalizzare le tue preferenze. Per maggiori informazioni, consulta la nostra<a
                    id="linkCookieBanner" href="https://unitiva.it/cookie" target="_blank"> Cookie Policy.</a></p>
                <hr className="hrCookie" />
                <div className="containerFormControl">
                  <div className="form-control">
                    <p className="p-cookie">Cookie tecnici</p>
                    <label className="switchCookie">
                      <input type="checkbox" className="checkboxSwitchDis" id="unitivaCheckbox" checked disabled />
                      <span className="sliderCookie round"></span>
                    </label>
                  </div>
                  <div className="form-control1">
                    <p className="p-cookie">Cookie analitici</p>
                    <label className="switchCookie">
                      <input type="checkbox" className="checkboxSwitch" id="analyticsCheckbox" checked={checkedSwitch} onChange={handelCheckBox}/>
                      <span className="sliderCookie round"></span>
                    </label>
                  </div>
                </div>
              </div>




              <div id="section2" className={`tabcontent ${activeSection === "section2" ? "active" : ""}`}>
                <div className="containerFormControl1">
                  <div className="form-control2">
                    <button className="toggle-button-cookie" onClick={() => toggleSection('section1')}
                    ><img src={downArrow} alt="down arrow" className={`${sections.section1 ? 'rotatedSvg' : ''}`} />
                      <p className="p-cookie2" id="pcookie" style={{color: `${sections.section1 ? "#5062cd" : " "}`}}>Cookie tecnici</p>
                    </button>
                    <div className="cookie-control">
                      <label className="switchCookie">
                        <input type="checkbox" className="checkboxSwitchDis" id="unitivaCheckbox" checked disabled />
                        <span className="sliderCookie round"></span>
                      </label>
                    </div>
                  </div>
                  <div className="cookie-description" id="cookie-tech">
                    <span className="short-text-cookie">Questi cookie sono essenziali per il funzionamento del
                      sito.</span><br />
                    {sections.section1 && (<span className="full-text-cookie">Di solito vengono impostati solo in risposta alle azioni da te
                      effettuate che costituiscono una richiesta di servizi, come l'impostazione delle preferenze di
                      privacy, l'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o
                      avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non
                      funzioneranno. <br />
                      <button className="toggle-button-cookie" onClick={() => toggleUnderSection("underSection1")}> <img src={downArrow} alt="down arrow" className={`${underSections.underSection1 ? 'rotatedSvg' : ''}`} />
                    
                        <p className="p-cookie" id="pcookie1" style={{color: `${underSections.underSection1 ? "#5062cd" : " "}`}}>
                          Unitiva=accepted</p>
                      </button> 
                      <div className="cookie-underdescription" id="cookie-tech1">
                        {underSections.underSection1 && (<span className="full-undertext-cookie">Il cookie registra la data e l'ora in cui l'utente accetta
                          la
                          privacy policy, e impedisce la visualizzazione futura della notifica della privacy,
                          migliorando l'esperienza utente sul sito. <br />
                          <span style={{ fontWeight: "bold" }}>Fornitore:</span> Unitiva.
                        </span>
                        )}

                      </div>
                    </span>)}


                  </div>
                  <hr className="hrCookie" />
                  <div className="form-control2">
                    <button className="toggle-button-cookie" onClick={() => toggleSection('section2')}
                    ><img src={downArrow} alt="down arrow" className={`${sections.section2 ? 'rotatedSvg' : ''}`} />
                      <p className="p-cookie2" id="pcookie2" style={{color: `${sections.section2 ? "#5062cd" : " "}`}}>Cookie analitici</p>
                    </button>
                    <div className="cookie-control">
                      <label className="switchCookie">
                      <input type="checkbox" className="checkboxSwitch" id="analyticsCheckbox" checked={checkedSwitch} onChange={handelCheckBox}/>
                        <span className="sliderCookie round"></span>
                      </label>
                    </div>
                  </div>
                  <div className="cookie-description" id="cookie-tech2">

                    <span className="short-text-cookie">Questi cookie raccolgono informazioni in forma aggregata e anonima
                      sulle visite al sito e la sua navigazione, in modo da ottimizzarne i contenuti.</span>
                    {sections.section2 && (
                      <span className="full-text-cookie">
                        <button className="toggle-button-cookie" onClick={() => toggleUnderSection("underSection2")}
                        ><img src={downArrow} alt="down arrow" className={`${underSections.underSection2 ? 'rotatedSvg' : ''}`} />
                          <p className="p-cookie" id="pcookie3" style={{color: `${underSections.underSection2 ? "#5062cd" : " "}`}}>
                            Google Analytics </p>
                        </button>
                        <div className="cookie-underdescription" id="cookie-tech3">
                          {underSections.underSection2 && (
                            <span className="full-undertext-cookie">
                              <p className="p-cookie">_ga</p><br />
                              Registra un ID univoco utilizzato per generare dati statistici su come il visitatore
                              utilizza il sito internet.
                              
                              <span style={{ fontWeight: "bold" }}>Fornitore:</span> Google.<br />
                              <span style={{ fontWeight: "bold" }}>Tipo:</span> Cookie HTTP.<br />
                              <span style={{ fontWeight: "bold" }}>Scadenza:</span> 2 anni.<br />
                              <br />
                              <p className="p-cookie">_ga_</p><br />
                              Viene utilizzato da Google Analytics per raccogliere dati sul numero di volte in cui un
                              utente ha visitato il sito web nonché le date della prima e dell'ultima visita.
                              <br />
                              <span style={{ fontWeight: "bold" }}>Fornitore:</span> Google.<br />
                              <span style={{ fontWeight: "bold" }}>Tipo:</span> Cookie HTTP.<br />
                              <span style={{ fontWeight: "bold" }}>Scadenza:</span> 2 anni.<br />
                            </span>
                          )}

                        </div>
                      </span>

                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="cols buttons-col">
            <button className="main__btn btn_cookie" onClick={acceptCookie}>Accetta tutti</button>
            <button className="main__btn btn_cookie" onClick={acceptCookiePreference}>Accetta la selezione</button>
            <button className="main__btn btn_cookie" onClick ={denyCookie}>Rifiuta</button>
          </div>
        </div>
      </div>
      
    </S.CookiesWrapper>
  ) : (

       <S.PopUpWrapper>
        <div className="popUp-cookie">
          <button type="button" className="popUp-cookie-button" onClick={() => setShowBanner(true)}>
            <img src={cookieIcon} alt="cookie" className="cookieIcon" />
            <div className="tooltip">
            <span className="tooltiptext">Gestione cookie</span>
            </div>
          </button>
        </div>
          </S.PopUpWrapper>
  );
};

export default Cookies;
